import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ORIGINS = ["Medan Hub (KNO)", "Padang Hub (PDG)", "Other / Binaka Airport (GNS)"];

const inputCls =
  "w-full px-4 py-3 rounded-xl bg-white/5 border border-white/15 text-white placeholder-white/30 text-sm focus:outline-none focus:border-terracotta transition-colors";
const labelCls =
  "block text-xs font-mono-clean uppercase tracking-wider text-sand-50/80 mb-2";

const BoardTransferForm = () => {
  const [form, setForm] = useState({
    name: "",
    contact: "",
    origin: ORIGINS[0],
    board_count: 1,
    details: "",
  });
  const [sending, setSending] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/enquiries/board-transfer`, {
        ...form,
        board_count: Number(form.board_count) || 1,
      });
      toast.success("Enquiry sent — we reply via WhatsApp or email within 24 hours.");
      setForm({ name: "", contact: "", origin: ORIGINS[0], board_count: 1, details: "" });
    } catch (err) {
      toast.error("Could not send your enquiry. Please try WhatsApp instead.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="bg-ocean-800 p-8 sm:p-10 rounded-3xl border border-white/10" data-testid="board-transfer-form-card">
      <h3 className="font-display text-2xl font-bold mb-2 text-white">Request Board Transfer Quote</h3>
      <p className="text-xs text-sand-50/70 mb-6">
        Tell us your route and board count. Our operations team confirms exact pickup logistics and pricing.
      </p>
      <form className="space-y-4" onSubmit={submit} data-testid="board-transfer-form">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className={labelCls} htmlFor="bt-name">Your Name</label>
            <input
              id="bt-name"
              data-testid="board-transfer-name-input"
              type="text"
              required
              value={form.name}
              onChange={set("name")}
              placeholder="e.g. Liam Campbell"
              className={inputCls}
            />
          </div>
          <div>
            <label className={labelCls} htmlFor="bt-contact">WhatsApp or Email</label>
            <input
              id="bt-contact"
              data-testid="board-transfer-contact-input"
              type="text"
              required
              value={form.contact}
              onChange={set("contact")}
              placeholder="+61 400 000 000"
              className={inputCls}
            />
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className={labelCls} htmlFor="bt-origin">Pickup Origin</label>
            <select
              id="bt-origin"
              data-testid="board-transfer-origin-select"
              value={form.origin}
              onChange={set("origin")}
              className={`${inputCls} bg-ocean-900`}
            >
              {ORIGINS.map((o) => (
                <option key={o} value={o}>{o}</option>
              ))}
            </select>
          </div>
          <div>
            <label className={labelCls} htmlFor="bt-count">Number of Board Bags</label>
            <input
              id="bt-count"
              data-testid="board-transfer-count-input"
              type="number"
              min="1"
              max="20"
              required
              value={form.board_count}
              onChange={set("board_count")}
              className={inputCls}
            />
          </div>
        </div>
        <div>
          <label className={labelCls} htmlFor="bt-details">Arrival Date & Board Dimensions</label>
          <textarea
            id="bt-details"
            data-testid="board-transfer-details-input"
            rows="3"
            value={form.details}
            onChange={set("details")}
            placeholder="Approx arrival date in Nias and quiver sizes (e.g., 2 x shortboards, 6'4 double coffin)"
            className={inputCls}
          />
        </div>
        <div className="pt-2">
          <button
            type="submit"
            data-testid="board-transfer-submit-button"
            disabled={sending}
            className="w-full py-4 rounded-xl bg-sand-50 text-ocean-900 font-semibold text-sm hover:bg-white transition-colors disabled:opacity-60"
          >
            {sending ? "Sending..." : "Submit Cargo Inquiry"}
          </button>
          <p className="text-[11px] text-sand-50/50 text-center mt-3 font-mono-clean">
            We reply directly via WhatsApp or Email within 24 hours.
          </p>
        </div>
      </form>
    </div>
  );
};

export default BoardTransferForm;
